export default {
	label: 'Sätted',
	adminRightsAreMissing: 'Admin õigused puuduvad!',
	customFieldsRights: 'Lisaväljade vaade ei ole saadaval "Kõik asutused" vaates!',
	EITS: 'Eesti Infoturbestandard (E-ITS)',
	RIA: 'Riigi Infosüsteemi Amet (RIA)',
	CC: 'CC BY 4.0',
	version: 'Versioon',
	backup: {
		tab: 'Varundus',
		description: 'Laadi alla täielik andmebaasi varukoopia selle paigalduse Cybsis 2.0-i migreerimiseks.',
		download: 'Laadi varukoopia alla',
	},
}
